import { PAGE_SIZE } from './PublicCatalogResults';
import useSearchParams from 'academy-common-lib/hooks/useSearchParams';
import { theme } from 'academy-common-lib/utils/Styling';
import ACSkeletonBox from 'academy-common-lib/components/loading/ACSkeletonBox';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { dropdownFilters } from '../publicCatalogConstants';
import { useGetMainFilterApplied, useGetPathFilterApplied } from '../publicCatalogFiltersHooks';
import { getSubMenuNameFromSubMenuOption } from '../publicCatalogDropdownUtils';
import PublicCatalogMobileCategoriesMenu from './PublicCatalogMobileCategoriesMenu/PublicCatalogMobileCategoriesMenu';
import PublicCatalogResultsText from './PublicCatalogResultsText';
import { useGetDropdownFilterApplied } from '../publicCatalogFiltersHooks';
import { useGetCatalogResultsFromUrlFilters } from '../publicCatalogResultsHooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MobileResultsDropdowns = () => {
  const dropdownFilterAppliedInfo = useGetDropdownFilterApplied();
  const pathFilterApplied = useGetPathFilterApplied();
  if (pathFilterApplied) {
    return /*#__PURE__*/_jsx(PublicCatalogMobileCategoriesMenu, {
      buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `academyPublic.catalogPage.filters.pathFilters.${pathFilterApplied}`
      }),
      buttonUse: "dropdown"
    });
  }
  if (!dropdownFilterAppliedInfo) return null;
  const {
    dropdownFilterApplied,
    dropdownFilterValue,
    isAppliedValueATopLevelOption
  } = dropdownFilterAppliedInfo;
  if (isAppliedValueATopLevelOption) {
    return /*#__PURE__*/_jsx(PublicCatalogMobileCategoriesMenu, {
      buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `academyPublic.catalogPage.filters.${dropdownFilterApplied}.${dropdownFilterValue}`
      }),
      buttonUse: "dropdown"
    });
  }
  const subMenuName = getSubMenuNameFromSubMenuOption(dropdownFilterApplied, dropdownFilterValue);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PublicCatalogMobileCategoriesMenu, {
      buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `academyPublic.catalogPage.filters.${dropdownFilterApplied}.${subMenuName}`
      }),
      buttonUse: "dropdown"
    }), /*#__PURE__*/_jsx("span", {
      className: "m-x-2",
      children: "/"
    }), /*#__PURE__*/_jsx(PublicCatalogMobileCategoriesMenu, {
      buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `academyPublic.catalogPage.filters.${dropdownFilterApplied}.${dropdownFilterValue}`
      }),
      buttonUse: "dropdown",
      subMenuName: subMenuName || undefined
    })]
  });
};
const MobileResultsBarsSkeletonLoader = () => /*#__PURE__*/_jsx("div", {
  "data-test-id": "results-display-loading",
  children: /*#__PURE__*/_jsx(ACSkeletonBox, {
    animated: true,
    backgroundcolor: theme.colors.GYPSUM,
    shimmercolor: theme.colors.BATTLESHIP,
    style: {
      width: '180px',
      height: '20px'
    }
  })
});
const PublicCatalogMobileResultsDisplay = () => {
  const [searchParams] = useSearchParams();
  const mainFilterApplied = useGetMainFilterApplied();
  const pathFilterApplied = useGetPathFilterApplied();
  const {
    publicCatalogData,
    publicCatalogError,
    publicCatalogLoading
  } = useGetCatalogResultsFromUrlFilters({
    pageSize: PAGE_SIZE
  });
  return /*#__PURE__*/_jsxs("div", {
    children: [publicCatalogLoading && /*#__PURE__*/_jsx(MobileResultsBarsSkeletonLoader, {}), !publicCatalogLoading && !publicCatalogError && publicCatalogData && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(PublicCatalogResultsText, {
        count: publicCatalogData.total || 0
      }), /*#__PURE__*/_jsxs("div", {
        children: [mainFilterApplied === 'search' && /*#__PURE__*/_jsx(UITruncateString, {
          style: {
            display: 'inline'
          },
          children: searchParams.search
        }), ' ', (dropdownFilters.includes(mainFilterApplied) || pathFilterApplied) && /*#__PURE__*/_jsx(MobileResultsDropdowns, {})]
      })]
    })]
  });
};
export default PublicCatalogMobileResultsDisplay;